import { FunctionComponent, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { getAppConfig, TIER } from 'studiokit-scaffolding-js'
import logo from './logo.svg'

import './Logo.css'

export const Logo: FunctionComponent = () => {
	const appConfig = getAppConfig()
	const tier = appConfig.TIER

	const tierOverlay = useMemo(() => {
		switch (tier) {
			case TIER.LOCAL:
				return <span>LOCAL</span>
			case TIER.DEV:
				return <span>DEV</span>
			case TIER.QA:
				return <span>QA</span>
			default:
				return null
		}
	}, [tier])

	return (
		<Link to="/" aria-label="Link to home page" id="Logo">
			<h1 className="mv0">
				<img src={logo} alt="ink2html" />
			</h1>
			{tierOverlay}
		</Link>
	)
}
